<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">Reconcile Trx.Debit - Account Receivable (Sub Modul vs GL)
        <div class="card-header-actions">
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="6">
              <b-row>
                <b-col class="pr-1" cols="8">
                    <b-input-group >
                      <b-input-group-prepend><label style="width:150px;">AR Account/Group</label></b-input-group-prepend>
                    <b-form-select v-model="model.account" :plain="true" :options="accounts"></b-form-select>
                    </b-input-group>
                </b-col>
                <b-col class="pl-1" cols="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="input-group-text">GL Acc.#</span></b-input-group-prepend>
                      <b-form-input v-model="model.kodeacc" readonly placeholder="GL Account Code"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>                      
        </b-col>
        <b-col lg="4">
                  <b-input-group >
                    <b-input-group-prepend><span class="pt-2 mr-2">Trx. Date</span></b-input-group-prepend>
                    <b-form-input v-model="model.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
                    <b-form-input v-model="model.tgl2" type="date" ></b-form-input>
                  </b-input-group>
        </b-col>
        <b-col lg="2">
            <b-button class="btn btn-success" @click="getData()" > <i class="fa fa-play"></i> Process</b-button>
        </b-col>
      </b-row>
      <b-card no-body>
          <template v-slot:header v-if="(filterShow=='Hide')">          
            <b-row >
                <b-col lg="3">
                  <b-input-group size="sm" class="mt-1">
                    <b-input-group-prepend><span class="pt-1 mr-1" >FILTER</span></b-input-group-prepend>
                    <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                        ></b-form-input>
                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                    </b-input-group-append>
                    </b-input-group>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>

                </b-col> 
                <b-col lg="9">
                  <b-form-group
                    label="FILTER ON :"
                    label-cols-sm="1"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="rekonsil">Rekon Status</b-form-checkbox>
                      <b-form-checkbox value="uraian1">Description Sub Modul</b-form-checkbox>
                      <b-form-checkbox value="uraian2">Description GL</b-form-checkbox>
                      <b-form-checkbox value="nilai1">Value Sub Modul </b-form-checkbox>
                      <b-form-checkbox value="nilai2">Value GL</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>                
                </b-col>                 
            </b-row>
        </template>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblLcy.fields"
                :current-page="tblLcy.page"
                :per-page="tblLcy.limit"
                :sort-by.sync="tblLcy.sortBy"
                :sort-desc.sync="tblLcy.sortDesc"
                :filter="filterInput"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
            <template v-slot:thead-top="data">
              <b-tr>
                <b-th colspan="6" class="text-center">SUB MODUL</b-th>
                <b-th variant="warning" class="text-center">REKON</b-th>
                <b-th variant="success" colspan="4" class="text-center">GL-ACCOUNTING</b-th>
              </b-tr>
            </template>

              <template v-slot:cell(tanggal1)="data">
                  <span v-if="(data.item.tanggal1)">{{ data.item.tanggal1 | moment("DD-MMM-YYYY") }}</span>
              </template>
              <template v-slot:cell(tanggal2)="data">
                  <span v-if="(data.item.tanggal2)">{{ data.item.tanggal2 | moment("DD-MMM-YYYY") }}</span>
              </template>
                <template v-slot:cell(nilaiori)="data">
                      {{ data.item.matauang }} &nbsp; {{ data.item.nilaiori | numFormat }}
                </template>
                <template v-slot:cell(nilai1)="data">
                      {{ data.item.nilai1 | numFormat }}
                </template>
                <template v-slot:cell(nilai2)="data">
                      {{ data.item.nilai2 | numFormat }}
                </template>
                <template v-slot:cell(valas_in)="data">
                      {{ data.item.valas_in | numFormat }}
                </template>
                <template v-slot:cell(valas_out)="data">
                      {{ data.item.valas_out | numFormat }}
                </template>
                <template v-slot:cell(sakhirOri)="data">
                      {{ data.item.sakhirOri | numFormat }}
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col lg="7">
                    <b-row >
                      <b-col cols="8">
                        <div class="ml-1">
                          Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                          to <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span> <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                          of {{tblLcy.total}} entries,   <span class="mr-1">limit per page :</span> 
                          <select  v-model="tblLcy.limit"  style="width:60px;">
                            <option>10</option>
                            <option>15</option>
                            <option>20</option>                            
                            <option>25</option>
                            <option>30</option>                            
                            <option>40</option>                            
                            <option>50</option>                            
                            <option>60</option>                            
                            <option>70</option>                            
                            <option>80</option>                            
                            <option>90</option>                            
                          </select>
                        </div>
                        <b-pagination  class="ml-1" 
                          align="left"
                          :total-rows="tblLcy.total"
                          :per-page="tblLcy.limit"
                          v-model="tblLcy.page"
                        ></b-pagination>
                      </b-col>
                      <b-col cols="4">            
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-2">
                          <b> {{ filterShow }}</b>  Filter
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col lg="5">
                  <b-form-row>
                    <b-col md="4">
                      <b-form-group label="Total Sub Modul" >
                          <my-number class="form-control text-right" v-model="subtotal.totalModul" :precision="2" disabled></my-number>
                      </b-form-group>                  
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Total GL" >
                            <my-number class="form-control text-right" v-model="subtotal.totalGl" :precision="2" disabled></my-number>
                        </b-form-group>                  
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Selisih" >
                            <my-number class="form-control text-right" v-model="subtotal.selisih" :precision="2" disabled></my-number>
                        </b-form-group>                  
                    </b-col>
                  </b-form-row>
                </b-col>

            </b-row>
      </b-card>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss" scoped>
 
</style>

<script>
import moment from 'moment';
import arreport from "../../apis/arreport";
import myNumber from "../../components/my-number";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model: {account:'',tgl1:'',tgl2:''},
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      rptLines : [],
      subtotal : {},
      filterShow:'Show',
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "nomor1",
            label: "Trx. Number",
            sortable: true
          },
          {
            key: "tanggal1",
            label: "Trx. Date",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "uraian1",
            label: "Description",
          },
          {
            key: "vendorinfo",
            label: "Customer",
            sortable: true
          },
          {
            key: "nilaiori",
            label: "Trx. Value (FCY)",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "nilai1",
            label: "Trx. Value (LCY)",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "rekonsil",
            label: "STATUS",
            thStyle: "width:30px",
            thClass: "text-center text-warning",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nomor2",
            label: "GL Number",
          thClass: "text-success",
            sortable: true
          },
          {
            key: "tanggal2",
            label: "GL. Date",
            thStyle: "width:90px",
            thClass: "text-center text-success",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "uraian2",
            thClass: "text-success",
            label: "Description",
          },
          {
            key: "nilai2",
            label: "GL Value",
            thStyle: "width:140px",
            thClass: "text-right text-success",
            tdClass: "text-right"
          },
        ]
      },
      filter: null,
      filterInput: null,
      filterOn: [],   
    };
  },
  components: {Loading, myNumber},
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    account() {
        return this.model.account;
    },
  },
  watch:{
    account: function(newval) {
      const obj=this.accounts.find(d => d.value === newval);
        this.model.namaacc=obj.text || '';
        this.model.kodeacc=obj.kodeacc;
        // console.log(`${this.model.account} | ${this.model.namaacc}`);
    },
    filterShow: function(newval) {
      setTimeout(() => {
              this.filter=''
      }, 200);
    },
    filter: function(newval) {
      // this.isBusy=true;
      setTimeout(() => {
            this.filterInput=newval;
      }, 800);
    },
  },   created: async function(){
      const accList = await arreport.postgroup();
      this.accounts = accList.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.model.tgl1=this.$store.state.user.tglaktif;
        this.model.tgl2=tgl2.format('YYYY-MM-DD');
  },  
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },     
    clearFilter() {
          this.filterOn= []   
          this.filter= '';   
    } ,
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.isLoading=true;
        const result = await arreport.rekondb(this.model);
        this.rptLines =  result[0];
        // console.log('this.rptLines :', this.rptLines.filter(r => r.rekonsil==0));
        this.subtotal = result[1][0];     
        this.subtotal.selisih=this.subtotal.totalModul-this.subtotal.totalGl;
        this.tblLcy.total = this.rptLines.length;        
        this.isLoading=false;      
       }
    },
    // getData: async function(ctx) {
    //     if (this.invalidFilter) {
    //         toastr.error('Please fill the form correctly.');
    //    } else {
    //     this.isLoading=true;
    //     const result = await arreport.rekondb(this.model);
    //     this.rptLines =  result[0];
    //     this.subtotal = result[1][0];     
    //     this.isLoading=false;      
    //    }
    // },
    // confirmAction: function() {
    //     toastr.info('Klik Pada TRX. NUMBER untuk PRINT VOUCHER');
    // },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await arreport.rekondbexport(this.model);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("/receivable/home");
    }
  }
};
</script>
